import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators'

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {

  private unsubscribe$ = new Subject();
  constructor(private router: Router) {

    router.events
      .pipe(
        takeUntil(this.unsubscribe$),
        filter(f => f instanceof NavigationEnd)
      )
      .subscribe((val: any) => {


        if (val.url === '/' || val.url === '/home') {
          document.body.classList.remove('not-front')
        };

        window.scroll({
          top: 0,
          left: 0,
          behavior: 'smooth'
        });

      });

  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  ngOnInit(): void {

  }


}
